<template>
	<el-dialog
		:before-close="onBeforeClose"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		:show-close="noticesData.closeable === 1 || isCanClose"
		:title="noticesData.title || ''"
		:visible.sync="isShowNotices"
		:width="getDialogWidth"
		center
		custom-class="insureNotices"
		destroy-on-close
		top="16vh">
		<template>
			<el-row class="center_info_content" justify="center" type="flex">
				<el-col :span="22">
					<div>
						<span v-html="noticesData.content"></span>
					</div>
					<table style="width: 100%">
						<tr v-for="(itemData, index) in noticesData.items" :key="index">
							<td>
								<div v-if="isCheck" class="u-flex">
									<el-checkbox v-model="checkResultData[index]">
										<span v-html="itemData"></span>
									</el-checkbox>
								</div>
								<div v-else v-html="itemData"></div>
							</td>
						</tr>
					</table>
				</el-col>
			</el-row>
			<div slot="footer" style="margin-top: 20px">
				<div class="footer u-flex-col u-col-center">
					<div v-if="isHasScroll" class="u-m-b-10 u-font-weight-bold footer_hint u-flex u-col-center">
						<el-icon class="el-icon-d-arrow-left u-font-weight-bold u-m-r-5"></el-icon>
						请滑动鼠标至底部，阅读并确认全部内容！
					</div>
					<div class="u-flex u-row-center">
						<el-button v-if="noticesData.cancelText" style="margin: 0 15px" @click="onCancel">
							{{ noticesData.cancelText }}
						</el-button>
						<el-button
							v-if="noticesData.confirmText"
							:disabled="currentCount > 0 || (isHasScroll && !isScrollEnd)"
							style="margin: 0 15px"
							type="primary"
							@click="onSure">
							{{ getConfirmText }}
						</el-button>
					</div>
				</div>
			</div>
		</template>
	</el-dialog>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {validatenull} from '../util/validate'
import {getInsureHint} from '../api/productCenterNew'
import {setStore} from '../util/store'

export default {
	name: 'InsureNotices',
	mixins: [],
	components: {},
	props: {
		isCanClose: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			isShowNotices: false,
			noticesData: {},
			currentCount: 0,
			timerInterval: null,
			rightBtnContent: '',
			//弹窗组件数据存储
			noticesDataList: [],
			currentTimeNum: 0,
			checkResultData: [],
			isHasScroll: false,
			isScrollEnd: false,
			currentBrokerInfo: {},
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
		//是否为选择框
		isCheck() {
			return this.noticesData.confirmType === 'check'
		},
		getDialogWidth() {
			let width = this.noticesData.width || ''
			return width ? (width * 115) / window.screen.width + '%' : '45%'
		},
		getConfirmText() {
			let {confirmText = ''} = this.noticesData
			return this.currentCount <= 0 ? confirmText : `(${this.currentCount}) ${confirmText}`
		},
	},
	watch: {
		currentCount(newVal) {
			if (newVal < 0) {
				// 倒计时结束时，清除倒计时
				this.currentCount = 0
				this.onCancelTimer()
			}
		},
	},
	methods: {
		//请求数据
		/**
		 * 投保提醒的参数，
		 * operate  ：（1=投保；2=批增；3=替换；4=附加方案投保；5=附加方案批准）
		 * 投保提醒增加一个批改场景字段，changeScene：
		 * 批改场景（101、新增雇员，102、替换雇员，103、删除雇员；104、修改雇员；401、修改投保人；402、修改被保人;
		 * 403、新增共同被保人404、批减被保人；901、批减人员;902、批减车辆;903、批改工种；904、批改投保座位数；
		 * 905、批改保额；201、退保;801、线下新增;802、线下替换;803、批减人员;804、批改工种；805、批改特约）
		 * @param queryData sourceProductId = '', productId = '', operate, changeScene = ''
		 * @param func 回调方法
		 * @returns {Promise<void>}
		 */
		async onGetHintInfoData(queryData, func = null) {
			try {
				console.log('onGetHintInfoData----', queryData)
				let {sourceProductId = '', productId = '', operate, changeScene = ''} = queryData
				if (!sourceProductId || !productId) {
					this.$alert('投保参数不正确！', '提示').then(() => {})
					return
				}
				//通过产品中心获取的提醒进行处理
				let tempData = await getInsureHint(queryData)
				let {code = -1, data = {}, msg = '获取投保提醒异常！'} = tempData.data || {}
				if (code === 0) {
					let {
						hintInfo = {},
						brokerInfo = {},
						productId: productIdNew = '',
						sourceProductId: sourceProductIdNew = '',
					} = data
					func && func({productIdNew, sourceProductIdNew})
					//获取投保跳转flag	是否切换域名（1：是 2：否）, host
					// host	主机域名
					setStore({name: 'brokerInfo', content: brokerInfo, type: 'session'})
					//提醒跳转
					this.currentBrokerInfo = brokerInfo
					//先判断当前域名和返回数据对不对
					let {flag = 0, host = ''} = this.currentBrokerInfo
					let localHostName = window.location.origin
					console.log('localHost-----', localHostName)
					//暂时注释
					// if (!localHostName.includes('localhost')) {
					// 	if ((flag === 1 && host === localHostName) || (flag === 2 && host !== localHostName)) {
					// 		this.$alert('投保跳转不正确！', '提示').then(() => {})
					// 		return
					// 	}
					// }
					if (validatenull(hintInfo)) {
						//没有投保提醒
						this.$emit('onToSure', brokerInfo)
					} else {
						//提醒
						this.onShowNotices(hintInfo)
					}
				}
			} catch (e) {
				this.$alert(`${e.message}`, '提示').then(() => {})
			}
		},
		//根据data进行弹窗，不做缓存了！！！
		onShowNotices(hintInfo = {}) {
			console.log('弹窗数据------', hintInfo)
			this.checkResultData = []
			this.isShowNotices = false
			this.isHasScroll = false
			this.isScrollEnd = false
			if (validatenull(hintInfo)) {
				return
			}
			let {
				confirmAutoStatus = -1,
				cancelAutoStatus = -1,
				confirmParams = {},
				confirmAction = 0,
				confirmNext = {},
				cancelNext = {},
				items = [],
				confirmType = '',
				width = 0,
			} = hintInfo
			if (confirmAutoStatus === 1) {
				//不需要弹窗！，直接发数据
				this.$emit('onConfirmAutoStatus', {confirmAction, confirmParams})
				this.onShowNotices(confirmNext)
				return
			}
			if (cancelAutoStatus === 1) {
				//不需要弹窗！，直接发数据
				this.$emit('cancelAutoStatus', confirmParams)
				this.onShowNotices(cancelNext)
				return
			}
			if (items.length > 0 && confirmType === 'check') {
				for (let item of items) {
					this.checkResultData.push(false)
				}
			}
			setTimeout(() => {
				this.isShowNotices = true
				this.noticesData = hintInfo
				let {timer = 0} = hintInfo
				if (timer > 0) {
					//开启倒计时
					this.currentCount = timer
					this.onDealTimer()
				}
				this.$nextTick(() => {
					let dialogBody = document.getElementsByClassName('el-dialog__body')[0] // 获取滚动条的dom
					if (!dialogBody) {
						return
					}
					let {scrollTop = 0, clientHeight = 0, scrollHeight = 0} = dialogBody
					//有滚动条，提醒滚动到底部！！
					if (clientHeight < scrollHeight) {
						this.isHasScroll = true
					}
					console.log('距顶部' + scrollTop + '可视区高度' + clientHeight + '滚动条总高度' + scrollHeight)
					dialogBody.onscroll = () => {
						if (this.isScrollEnd) {
							return
						}
						let {
							scrollTop: scrollTop1 = 0,
							clientHeight: clientHeight1 = 0,
							scrollHeight: scrollHeight1 = 0,
						} = dialogBody
						if (scrollTop1 + clientHeight1 >= scrollHeight1 - 30) {
							// 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部
							console.log('到达底部了-----')
							this.isScrollEnd = true
						}
					}
				})
			}, 300)
		},
		onBeforeClose(done) {
			console.log('关闭了！！！')
			this.onCancelTimer()
			done()
			this.$emit('update:isShowNotices', false)
			this.$emit('onToCancel')
		},
		//处理倒计时
		onDealTimer() {
			//先去除倒计时
			this.timerInterval = setInterval(() => {
				this.currentCount = this.currentCount - 1
				if (this.currentCount <= 0) {
					//结束
					clearInterval(this.timerInterval)
					this.timerInterval = null
				}
			}, 1000)
		},
		onCancelTimer() {
			if (this.timerInterval) {
				clearInterval(this.timerInterval)
				this.timerInterval = null
			}
			//重置数据
			this.currentCount = 0
		},
		onSure() {
			//如果是选择框，则判断是否已经选了
			if (this.checkResultData.length > 0 && this.isCheck) {
				let tempIndex = this.checkResultData.findIndex((itemData) => !itemData)
				if (tempIndex !== -1) {
					this.$message.error('请勾选并同意相关条款！')
					return
				}
			}
			this.onNextStep(1)
		},
		onCancel() {
			this.onNextStep()
		},
		//下一步 1:sure 0:cancel
		onNextStep(type = 0) {
			//清除倒计时
			this.onCancelTimer()
			//点击确定了！！
			//先判断是否进入投保
			let {
				confirmAction = 0,
				confirmNext = null,
				cancelAction = 0,
				cancelNext = null,
				confirmParams = {},
				cancelParams = {},
			} = this.noticesData
			//特殊处理数据
			//confirmAction  1 投保
			if (type === 1) {
				//点击确认
				if (confirmNext) {
					//下一步
					this.onShowNotices(confirmNext)
				} else if (confirmAction === 1) {
					//进入投保
					this.$emit('onToInsure', this.currentBrokerInfo)
				} else if (confirmAction !== 0) {
					//根据confirmAction需要发送的
					this.$emit('onToSure', Object.assign({confirmAction, confirmParams}, this.currentBrokerInfo))
				} else {
					this.$emit('onToSureEnd')
				}
			} else {
				if (cancelNext) {
					//下一步
					this.onShowNotices(cancelNext)
				} else {
					//根据cancelAction来判断需不需要发送回调！！！！ 一般是不需要发送的
					this.$emit('onToCancel', {cancelAction, cancelParams})
				}
			}
			setTimeout(() => {
				this.isShowNotices = false
			}, 200)
		},
	},
	mounted() {},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style scoped>
table {
	border-collapse: collapse;
	margin: 0 auto;
}

table,
th,
td {
	padding: 0 10px;
	border: 1px solid #cbc8c8;
}

::v-deep .el-dialog--center .el-dialog__body {
	padding: 0 30px;
}

::v-deep .el-checkbox__label {
	display: inline-grid;
	white-space: pre-line;
	word-wrap: break-word;
	overflow: hidden;
	line-height: 20px;
}

::v-deep .insureNotices .el-dialog__body {
	max-height: 500px;
	overflow: auto;
}

.footer_hint {
	font-size: 0.8rem;
	color: #999;
	line-height: 18px;
}

.el-icon-d-arrow-left {
	transform: rotate(-90deg);
	font-size: 18px;
}
</style>
